import { render, staticRenderFns } from "./resource-links.vue?vue&type=template&id=2106d135&lang=pug&"
import script from "./resource-links.vue?vue&type=script&lang=js&"
export * from "./resource-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports